import { AxiosError } from "axios";

type ApiErrorBody = { error?: { message?: string; code?: number } };

const DEFAULT_MESSAGE = "오류가 발생했습니다.";

/**
 * 에러 객체에서 사용자용 메시지를 추출한다(중복되던 추출 체인 공통화).
 * - 문자열로 reject 된 경우(일부 getXApi 규약) → 그 문자열
 * - AxiosError → response.data.error.message (백엔드 CommonResponse 의 error.message)
 * - 그 외 Error → error.message
 * - 추출 실패 → fallback
 *
 * options.preferFallback=true: 서버 메시지가 없을 때 raw axios 메시지("Network Error"/"timeout..." 등)를
 *   노출하지 않고 fallback 을 쓴다. 로그인 등 사용자 화면에 영문 axios 메시지가 새는 것을 막는 용도.
 */
export function extractApiError(
    error: unknown,
    fallback: string = DEFAULT_MESSAGE,
    options?: { preferFallback?: boolean }
): string {
    if (typeof error === "string") return error || fallback;
    const e = error as AxiosError<ApiErrorBody> & { message?: string };
    const serverMessage = e?.response?.data?.error?.message;
    if (serverMessage) return serverMessage;
    if (options?.preferFallback) return fallback;
    return e?.message || fallback;
}
